/*!
 * TableView - Vue tableau / tableur pour IconsView
 */

import BaseView from './BaseView';

export default class TableView extends BaseView {
    constructor(plugin) {
        super(plugin, 'table');
    }

    createContainer(element) {
        const myself = this.plugin;
        this.container = $('<table class="t_info"></table>');
        myself.container = this.container;

        const columns = [];
        const tableHeaderColumns = myself.getViewColumns('table');
        const defaultTableIconSize = myself.getViewIconSize('table');

        if (tableHeaderColumns && tableHeaderColumns.length) {
            $.each(tableHeaderColumns, (indexView, column) => {
                const label = column.label || '';
                const alignCls = column.align ? ' ' + column.align : '';
                const customCls = (column.class || column.cls) ? ' ' + (column.class || column.cls) : '';
                const sizeStyle = column.size ? (isNumeric(column.size) ? 'style="width:' + column.size + '%;"' : 'style="width:' + column.size + ';"') : '';
                const isSortable = column.sortable !== false;
                let columnData = '';

                if (column.type === 'action' || column.type === 'actions') {
                    columnData = '<th draggable="true" class="iv__item__action' + alignCls + customCls + '" ' + sizeStyle + '>' + label + '</th>';
                } else if (column.type === 'label') {
                    columnData = '<th draggable="true" class="iv__item__name' + alignCls + customCls + '" ' + (isSortable ? 'data-sort="name"' : '') + ' ' + sizeStyle + '>' + label + '</th>';
                } else if (column.type === 'icon') {
                    let colSize = column.size;
                    if (colSize === 'small') colSize = 24;
                    else if (colSize === 'medium') colSize = 32;
                    else if (colSize === 'large' || colSize === 'hd') colSize = 48;
                    const currentSize = (colSize && isNumeric(colSize)) ? parseInt(colSize, 10) : defaultTableIconSize;
                    const badgeCol = '<th class="iv__item__col-badge" style="width: 32px; padding: 0; text-align: center;"></th>';
                    columnData = badgeCol + '<th draggable="true" class="iv__item__image' + alignCls + customCls + '" style="width: ' + (parseInt(currentSize, 10) + 10) + 'px;">' + ((currentSize > 24) ? label : '') + '</th>';
                } else {
                    const sortAttr = (isSortable && column.name) ? 'data-sort="' + column.name + '" ' : '';
                    columnData = '<th draggable="true" '
                            + sortAttr
                            + 'class="' + alignCls.trim() + customCls + '" '
                            + (column.type ? 'data-type="' + column.type + '" ' : '')
                            + sizeStyle
                            + '>' + label + '</th>';
                }
                columns.push(columnData);
            });
        }

        const containerHeader = '<tr>' + columns.join('') + '</tr>';
        this.container.append(containerHeader);

        // Tri sur en-têtes
        if (myself.options && myself.options.features && myself.options.features.reorganize) {
            this.container.find('th[data-sort]').click(function () {
                const button = $(this);
                const grid = button.closest('.iconGrid');
                myself.action({
                    action: 'sort',
                    order: button.data('sort'),
                    type: button.data('type'),
                }, grid);
            });
        } else {
            this.container.find('th[data-sort]').css('cursor', 'default');
        }

        // Initialiser le redimensionnement interactif des colonnes
        this.initColumnResizers();

        // Initialiser le glisser-déposer des colonnes pour réorganiser l'ordre
        this.initColumnDraggable();

        myself.containerView.addClass('iv__view iv__view--table view view-table');
        element.append(this.container);
        if (myself.preview) {
            element.append(myself.preview);
        }

        return this.container;
    }

    /**
     * Permet de glisser/déposer (drag & drop) les colonnes d'en-tête pour changer leur ordre
     */
    initColumnDraggable() {
        const myself = this.plugin;
        const $table = this.container;
        const $headerRow = $table.find('> tr:first-child');
        const $ths = $headerRow.find('> th');
        const storageOrderKey = 'iv_table_col_order_' + (myself.name || myself.uid || window.location.pathname);

        // 1. Restaurer l'ordre des colonnes depuis le localStorage si présent
        try {
            const rawOrder = localStorage.getItem(storageOrderKey);
            if (rawOrder) {
                const savedOrder = JSON.parse(rawOrder);
                if (Array.isArray(savedOrder) && savedOrder.length) {
                    this.applyColumnOrder(savedOrder);
                }
            }
        } catch (e) {}

        // 2. Activer le drag & drop natif sur chaque th (sauf badge)
        let draggedTh = null;
        let draggedIndex = -1;

        $table.on('dragstart', '> tr:first-child > th', function (e) {
            const $th = $(this);
            if ($th.hasClass('iv__item__col-badge')) {
                e.preventDefault();
                return false;
            }
            draggedTh = this;
            draggedIndex = $th.index();
            $th.addClass('iv__th--col-dragging');
            e.originalEvent.dataTransfer.effectAllowed = 'move';
            e.originalEvent.dataTransfer.setData('text/plain', String(draggedIndex));
        });

        $table.on('dragend', '> tr:first-child > th', function () {
            $(this).removeClass('iv__th--col-dragging');
            $table.find('th').removeClass('iv__th--drag-over-left iv__th--drag-over-right');
            draggedTh = null;
            draggedIndex = -1;
        });

        $table.on('dragover', '> tr:first-child > th', function (e) {
            e.preventDefault();
            if (!draggedTh || draggedTh === this) return;

            const $targetTh = $(this);
            if ($targetTh.hasClass('iv__item__col-badge')) return;

            e.originalEvent.dataTransfer.dropEffect = 'move';
            const rect = this.getBoundingClientRect();
            const relX = e.clientX - rect.left;
            const isLeftHalf = relX < rect.width / 2;

            $table.find('th').removeClass('iv__th--drag-over-left iv__th--drag-over-right');
            if (isLeftHalf) {
                $targetTh.addClass('iv__th--drag-over-left');
            } else {
                $targetTh.addClass('iv__th--drag-over-right');
            }
        });

        $table.on('dragleave', '> tr:first-child > th', function () {
            $(this).removeClass('iv__th--drag-over-left iv__th--drag-over-right');
        });

        $table.on('drop', '> tr:first-child > th', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const targetTh = e.currentTarget;
            if (!draggedTh || draggedTh === targetTh) return;

            const $targetTh = $(targetTh);
            if ($targetTh.hasClass('iv__item__col-badge')) return;

            const fromIndex = $(draggedTh).index();
            let toIndex = $targetTh.index();

            const rect = targetTh.getBoundingClientRect();
            const relX = e.clientX - rect.left;
            const insertAfter = relX >= rect.width / 2;

            $table.find('th').removeClass('iv__th--drag-over-left iv__th--drag-over-right iv__th--col-dragging');

            this.moveColumn(fromIndex, toIndex, insertAfter);

            // Mettre à jour et sauvegarder le nouvel ordre des colonnes
            try {
                const newOrder = [];
                $table.find('> tr:first-child > th').each(function () {
                    const $th = $(this);
                    const colKey = $th.data('sort') || $th.attr('class') || '';
                    newOrder.push(colKey);
                });
                this.currentColumnOrder = newOrder;
                localStorage.setItem(storageOrderKey, JSON.stringify(newOrder));
            } catch (err) {}
        });
    }

    /**
     * Déplace la colonne à la position fromIndex vers toIndex sur toutes les lignes (th et td)
     */
    moveColumn(fromIndex, toIndex, insertAfter) {
        const $table = this.container;
        $table.find('> tr, > tbody > tr').each(function () {
            const $row = $(this);
            const $cells = $row.children('th, td');
            const $fromCell = $cells.eq(fromIndex);
            const $toCell = $cells.eq(toIndex);

            if ($fromCell.length && $toCell.length && fromIndex !== toIndex) {
                if (insertAfter) {
                    $toCell.after($fromCell);
                } else {
                    $toCell.before($fromCell);
                }
            }
        });
    }

    /**
     * Réapplique un ordre de colonnes mémorisé
     */
    applyColumnOrder(orderedKeys) {
        const $table = this.container;
        const $ths = $table.find('> tr:first-child > th');
        const thKeyMap = {};

        $ths.each(function (idx) {
            const $th = $(this);
            const key = $th.data('sort') || $th.attr('class') || '';
            thKeyMap[key] = idx;
        });

        this.columnKeyIndexMap = thKeyMap;
        this.currentColumnOrder = orderedKeys;

        // Réordonner les colonnes de chaque ligne existante
        $table.find('> tr, > tbody > tr').each(function () {
            const $row = $(this);
            const $cells = $row.children('th, td');
            orderedKeys.forEach((key) => {
                const cellIdx = thKeyMap[key];
                if (cellIdx !== undefined && $cells.eq(cellIdx).length) {
                    $row.append($cells.eq(cellIdx));
                }
            });
        });
    }

    /**
     * Initialise les poignées de redimensionnement (resizers) sur chaque colonne th
     */
    initColumnResizers() {
        const myself = this.plugin;
        const $table = this.container;
        const $ths = $table.find('> tr:first-child > th');
        const storageKey = 'iv_table_widths_' + (myself.name || myself.uid || window.location.pathname);

        // Restaurer les largeurs sauvegardées dans localStorage si disponibles
        let savedWidths = null;
        try {
            const raw = localStorage.getItem(storageKey);
            if (raw) savedWidths = JSON.parse(raw);
        } catch (e) {}

        $ths.each(function (i) {
            const $th = $(this);
            if ($th.hasClass('iv__item__col-badge')) return;

            // Appliquer largeur sauvegardée si présente
            const colId = $th.data('sort') || $th.attr('class') || ('col_' + i);
            if (savedWidths && savedWidths[colId]) {
                $th.css('width', savedWidths[colId] + 'px');
            }

            // Créer la poignée de redimensionnement
            const $resizer = $('<div class="iv__table-resizer"></div>');
            $th.append($resizer);

            $resizer.on('mousedown', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const $root = myself.element || $table.closest('.iv');
                const thOffset = $th.offset();
                const thLeft = thOffset.left;

                $th.addClass('iv__th--resizing');
                $table.addClass('iv__table--resizing');
                $root.addClass('iv--colscaling');
                $('body').css('cursor', 'col-resize');

                const onMouseMove = (moveEvent) => {
                    // Calcul direct et fluide basé sur la position absolue du curseur par rapport au bord gauche de la colonne
                    const calculatedWidth = moveEvent.pageX - thLeft;
                    const newWidth = Math.max(40, Math.round(calculatedWidth));
                    $th.css('width', newWidth + 'px');
                };

                const onMouseUp = () => {
                    $(document).off('mousemove.ivColResize', onMouseMove);
                    $(document).off('mouseup.ivColResize', onMouseUp);
                    $th.removeClass('iv__th--resizing');
                    $table.removeClass('iv__table--resizing');
                    $root.removeClass('iv--colscaling');
                    $('body').css('cursor', '');

                    // Sauvegarder dans localStorage
                    try {
                        const widths = {};
                        $table.find('> tr:first-child > th').each(function (idx) {
                            const $col = $(this);
                            const id = $col.data('sort') || $col.attr('class') || ('col_' + idx);
                            widths[id] = Math.round($col.outerWidth());
                        });
                        localStorage.setItem(storageKey, JSON.stringify(widths));
                    } catch (err) {}
                };

                $(document).on('mousemove.ivColResize', onMouseMove);
                $(document).on('mouseup.ivColResize', onMouseUp);
            });
        });
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return null;

        const defaultTableIconSize = myself.getViewIconSize('table');
        myself.viewThumbsHeight = defaultTableIconSize;
        myself.viewThumbsWidth = defaultTableIconSize;
        myself.viewItemWidthRatio = 0;
        myself.viewItemThumbsMode = false;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const columns = [];
        const tableCols = myself.getViewColumns('table');

        if (tableCols && tableCols.length) {
            $.each(tableCols, (indexView, column) => {
                let columnData = '<td>&nbsp;</td>';
                const alignCls = column.align ? ' ' + column.align : '';
                const customCls = (column.class || column.cls) ? ' ' + (column.class || column.cls) : '';

                if (column.type === 'action') {
                    if (data.actions && !data.special) {
                        const action = data.actions[column.name];
                        if (action) {
                            const buttonIcon = myself.renderIconImage('small', action.icon);
                            columnData = '<td class="iv__item__action' + alignCls + customCls + '">'
                                    + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                    + '</td>';
                        }
                    }
                } else if (column.type === 'actions') {
                    if (data.actions && !data.special) {
                        const actionList = column.actions || Object.keys(data.actions);
                        const renderedButtons = [];
                        $.each(actionList, (idx, actName) => {
                            const action = data.actions[actName];
                            if (action) {
                                const buttonIcon = myself.renderIconImage('small', action.icon);
                                renderedButtons.push('<button class="action--default action" title="' + (action.label || actName) + '" data-action="' + actName + '">' + buttonIcon + '</button>');
                            }
                        });
                        columnData = '<td class="iv__item__action iv__item__actions' + alignCls + customCls + '">'
                                + renderedButtons.join(' ')
                                + '</td>';
                    }
                } else if (column.type === 'input') {
                    myself.reloadInput = true;
                    if (data.input) {
                        const inputProps = data.input[column.name];
                        const input = Array.isArray(inputProps) ? inputProps[0] : inputProps;
                        if (input) {
                            columnData = '<td class="iv__item__input' + alignCls + customCls + '" data-property="' + column.name + '">'
                                    + input
                                    + '</td>';
                        }
                        if (Array.isArray(inputProps) && inputProps[1]) {
                            setTimeout(function () {
                                try { eval(inputProps[1]); } catch (e) {}
                            }, 10);
                        }
                    }
                } else if (column.type === 'label') {
                    columnData = '<td class="iv__item__name' + alignCls + customCls + '">' + (data.label !== undefined && data.label !== null ? data.label : '') + '</td>';
                } else if (column.type === 'icon') {
                    let colSize = column.size;
                    if (colSize === 'small') colSize = 24;
                    else if (colSize === 'medium') colSize = 32;
                    else if (colSize === 'large' || colSize === 'hd') colSize = 48;
                    const currentSize = (colSize && isNumeric(colSize)) ? parseInt(colSize, 10) : defaultTableIconSize;
                    const badgeCell = '<td class="iv__item__col-badge" style="width: 32px; padding: 0; text-align: center; vertical-align: middle;"><div class="iv__item__table-badge"></div></td>';
                    columnData = badgeCell + '<td class="iv__item__data iv__item__icon' + alignCls + customCls + '"><div class="iv__item__image size-' + currentSize + '" style="width: ' + currentSize + 'px; height: ' + currentSize + 'px;">' + myself.renderIconImage(currentSize, column.name ? data[column.name] : data.icon, data, 'img') + '</div></td>';
                } else if (column.type === 'detail') {
                    const val = (data.detail !== undefined && data.detail !== null) ? data.detail : ((data.data && data.data.detail) ? data.data.detail : '');
                    columnData = '<td class="iv__item__data iv__item__detail' + alignCls + customCls + '">' + val + '</td>';
                } else {
                    const rawVal = (data[column.name] !== undefined && data[column.name] !== null)
                        ? data[column.name]
                        : ((data.data && data.data[column.name] !== undefined) ? data.data[column.name] : undefined);

                    const colNameCls = column.name ? ' iv__item__data--' + column.name : '';
                    const colNameAttr = column.name ? ' data-name="' + column.name + '"' : '';

                    if (column.format || column.type) {
                        const formattedHtml = myself.formatCellValue(rawVal, column, data);
                        columnData = '<td class="iv__item__data' + colNameCls + alignCls + customCls + '"' + colNameAttr + '>' + formattedHtml + '</td>';
                    } else if (rawVal !== undefined && rawVal !== null) {
                        columnData = '<td class="iv__item__data' + colNameCls + alignCls + customCls + '"' + colNameAttr + '>' + rawVal + '</td>';
                    }
                }
                columns.push(columnData);
            });
        }

        const code = '<tr class="' + currentClassAll + '">' + columns.join('') + '</tr>';
        const currentIcon = $(code);
        const currentIconReact = currentIcon.find('td.iv__item__image, td.iv__item__data, td.iv__item__name');

        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIconReact, data, currentType, path);
        this.renderBadge(data, currentIcon);

        // Si un ordre personnalisé de colonnes est actif, réordonner les cellules de la ligne
        if (this.currentColumnOrder && this.currentColumnOrder.length) {
            const $cells = currentIcon.children('td');
            const thKeyMap = this.columnKeyIndexMap || {};
            this.currentColumnOrder.forEach((key) => {
                const cellIdx = thKeyMap[key];
                if (cellIdx !== undefined && $cells.eq(cellIdx).length) {
                    currentIcon.append($cells.eq(cellIdx));
                }
            });
        }

        if (typeof myself.updateTableBadgeColumnVisibility === 'function') {
            myself.updateTableBadgeColumnVisibility();
        }

        return currentIcon;
    }
}
